// deps
import React, { ReactElement } from "react";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import classNames from "classnames";

// interfaces
import { BannerData } from "@payment-ui/interfaces/PaymentBanner";

// styles
import styles from "../PaymentBanner.scss";

// test-ids
import { PAYMENT_BANNER_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface ImageMediaBannnerProps {
    banner: BannerData;
    handleClick: (e: React.MouseEvent) => void;
    containerClassName?: string;
    bannerDimensions?: { width: number; height: number };
}

export function ImageMediaBannner({
    handleClick,
    banner,
    containerClassName,
    bannerDimensions,
}: ImageMediaBannnerProps): ReactElement {
    const containerStyles = classNames(styles.imageBanner, containerClassName);
    const bannerAttr = bannerDimensions ?? {};
    return (
        <div onClick={handleClick} className={containerStyles} data-testid={PAYMENT_BANNER_TEST_IDS.IMAGE_CONTAINER}>
            <img
                src={getCloudinaryUrl(banner.backgroundImage, { width: 800 })}
                alt={banner.title ?? ""}
                className={styles.imageBannerImage}
                {...bannerAttr}
            />
        </div>
    );
}
